import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CheckCircle, Loader2, Copy, AlertCircle } from 'lucide-react';
import { toast } from 'sonner';
import { useT } from '../context/LanguageContext';

import { API_BASE as BASE } from '../lib/apiBase';

export default function CheckoutSuccessPage() {
  const { t } = useT();
  const [status, setStatus] = useState('checking'); // checking | paid | failed
  const [data, setData] = useState(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get('session_id');
    let cancelled = false;
    if (!sid) {
      const t = setTimeout(() => { if (!cancelled) setStatus('failed'); }, 0);
      return () => { cancelled = true; clearTimeout(t); };
    }
    const poll = async (n = 0) => {
      if (cancelled) return;
      if (n > 10) { setStatus('failed'); return; }
      setAttempt(n + 1);
      try {
        const r = await axios.get(`${BASE}/api/webshop/status/${sid}`);
        if (r.data.payment_status === 'paid' && r.data.license_key) {
          setData(r.data); setStatus('paid'); return;
        }
        setTimeout(() => poll(n + 1), 2000);
      } catch {
        setTimeout(() => poll(n + 1), 2000);
      }
    };
    poll(0);
    return () => { cancelled = true; };
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#f3f6fb', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 32, maxWidth: 560, width: '100%', boxShadow: '0 10px 30px rgba(15,23,42,.1)' }} data-testid="checkout-success-card">
        {status === 'checking' && (
          <div style={{ textAlign: 'center' }}>
            <Loader2 size={42} className="spin" color="#2563eb" />
            <h2 style={{ margin: '14px 0 6px' }}>{t('Betaling verwerken...', 'Betaling verwerken...')}</h2>
           <p style={{ color: '#64748b', fontSize: 13 }}>
  {t('Even geduld, we controleren je betaling', 'Even geduld, we controleren je betaling')} ({t('poging', 'poging')} {attempt}/10).
</p></div>
        )}
        {status === 'paid' && data && (
          <div>
            <div style={{ textAlign: 'center', marginBottom: 18 }}>
              <CheckCircle size={48} color="#10b981" />
              <h2 style={{ margin: '12px 0 4px' }}>{t('Betaling succesvol!','Betaling succesvol!')}</h2>
              <p style={{ color: '#64748b', fontSize: 13 }}>{data.plan} {t('licentie is direct beschikbaar.', 'licentie is direct beschikbaar.')}}</p>
            </div>
            <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: 14, marginBottom: 14 }}>
              <div style={{ fontSize: 11, color: '#64748b', marginBottom: 6 }}>{t('JOUW LICENTIEKEY:','JOUW LICENTIEKEY:')}</div>
              <code data-testid="license-key" style={{ fontSize: 11, wordBreak: 'break-all', color: '#0f172a', display: 'block', marginBottom: 8 }}>{data.license_key}</code>
              <button data-testid="copy-key" onClick={() => { navigator.clipboard.writeText(data.license_key); toast.success(t('Gekopieerd!', 'Gekopieerd!')); }}
                style={{ background: '#0f172a', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: 6, fontSize: 12, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                <Copy size={12} /> {t('Kopieer key','Kopieer key')}
              </button>
            </div>
            <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.6, marginBottom: 14 }}>
              {t('We hebben de key ook gemaild naar','We hebben de key ook gemaild naar')} <b>{data.email}</b>. Activeer als volgt:
            </p>
            <ol style={{ fontSize: 13, color: '#475569', paddingLeft: 20, lineHeight: 1.8, marginBottom: 20 }}>
           <li>{t('Log in of maak een account aan op', 'Log in of maak een account aan op')} <a href="/" style={{ color: '#2563eb' }}>monteurcentraal.com</a></li>
<li>{t('Ga naar', 'Ga naar')} <b>{t('Instellingen → Licentie', 'Instellingen → Licentie')}</b></li>
<li>{t('Plak de key en klik', 'Plak de key en klik')} <b>{t('Activeren', 'Activeren')}</b></li>
            </ol>
            <a href="/" style={{ display: 'block', background: '#2563eb', color: '#fff', textAlign: 'center', padding: 12, borderRadius: 8, textDecoration: 'none', fontWeight: 600 }}>{t("Naar inloggen →","Naar inloggen →")}</a>
          </div>
        )}
        {status === 'failed' && (
          <div style={{ textAlign: 'center' }}>
            <AlertCircle size={42} color="#ef4444" />
            <h2 style={{ margin: '14px 0 6px' }}>{t('Betaling niet gevonden', 'Betaling niet gevonden')}</h2>

<p style={{ color: '#64748b', fontSize: 13, marginBottom: 18 }}>
  {t('We konden de betaling niet bevestigen. Check je e-mail of probeer opnieuw.', 'We konden de betaling niet bevestigen. Check je e-mail of probeer opnieuw.')}
</p>

<a href="/pricing" style={{ color: '#2563eb' }}>
  {t('← Terug naar prijzen', '← Terug naar prijzen')}
</a>
          </div>
        )}
      </div>
      <style>{`.spin { animation: spin 1s linear infinite; } @keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }`}</style>
    </div>
  );
}
